// extracted by mini-css-extract-plugin
export default {"root":"InconsistentCabinBaggageInfo-module__root___UgMj7","text":"InconsistentCabinBaggageInfo-module__text___Wdpoa"};